import { call, put, takeEvery } from 'redux-saga/effects';

import type ProviderAccount from '~/types/ProviderAccount';

import { ActionKeys } from '~/actions/constants';
import * as providersActions from '~/actions/providers.actions';
import * as shipmentsActions from '~/actions/shipments.actions';
import { getAllServiceLevels } from '~/services/providers.service';
import { fromJSON } from '~/types/ProviderAccount';

export function* fetchServiceLevelsByAccount() {
  try {
    const response = yield call(getAllServiceLevels);
    const accounts: ProviderAccount[] = fromJSON(response.data?.results ?? []);

    yield put(providersActions.fetchServiceLevelsByAccountSuccess(accounts));

    // Handles the case where shipments were fetched before service level configurations
    yield put(shipmentsActions.clearRateSelection());
    yield put(shipmentsActions.recalculateHiddenRates({}));
  } catch (err) {
    yield put(
      providersActions.fetchServiceLevelsByAccountError(
        'settings:automations:serviceLevelRetrievalError',
      ),
    );
  }
}

export default [takeEvery(ActionKeys.FETCH_SERVICE_LEVELS_BY_ACCOUNT, fetchServiceLevelsByAccount)];
